import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail'
import { ProgPriceForm } from './ProgPriceForm'
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';

export const ProgPriceDetail = () => {
  
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <ProgPriceForm /> },
    { id: 'entityProps', label: 'Properties', content: <EntityPropList parentEntity="PROG_PRICE" parentEntityObj={entityObj} />},
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs}/>
  )
}